


















import { Vue, Component, Prop, Ref, Emit } from 'vue-property-decorator'
import config from '../../config'
import { getFileType } from '../../utils/file'

@Component
export default class GlpFileViewer extends Vue {
  @Prop(String) name!: string

  @Prop(String) url!: string

  @Prop(String) title!: string

  @Prop(Function) onView!: any

  @Ref() image!: any

  imageUrl = ''

  get imageUrls () {
    return this.imageUrl ? [this.imageUrl] : []
  }

  get filename () {
    const idx = (this.url || '').lastIndexOf('/')
    if (idx >= 0) return (this.url || '').slice(idx + 1)
    return 'unkown'
  }

  get actualTitle () {
    return this.title || this.filename
  }

  get actualName () {
    return this.name || this.filename
  }

  get canPreview () {
    return ['image', 'pdf', 'word', 'excel', 'ppt'].includes(getFileType(this.url))
  }

  onPreview () {
    if (this.onView) {
      this.onView(this.url)
      return
    }
    if (getFileType(this.url) === 'pdf') config.previewPdf(this.url)
    else if (['word', 'excel', 'ppt'].includes(getFileType(this.url))) config.previewOffice(this.url)
    else if (getFileType(this.url) === 'image') {
      this.imageUrl = this.url
      this.image.clickHandler()
      this.$nextTick(() => {
        this.image.clickHandler()
      })
    } else {
      this.$message.info('尚不支持预览该类型文件')
    }
  }

  onDownload () {
    config.download(this.actualName, this.url)
  }
}
